import PropTypes from "prop-types";
import { useResponsiveStyles } from "../../styles/useResponsiveStyles";

export const ReportsPublished = ({ count }) => {
    const { getFontSize, getSectionStyle } = useResponsiveStyles();
    return (
        <div
            className="flex items-center justify-center gap-2 px-4 rounded bg-[#EDF2F7]"
            style={getSectionStyle("report")}
        >
            <span
                className="font-bold text-red-600 leading-none mb-0.5"
                style={getFontSize("stat")}
            >
                {count}
            </span>
            <span className=" text-gray-500" style={getFontSize("body1")}>
                Reports Published
            </span>
        </div>
    );
};

ReportsPublished.propTypes = {
    count: PropTypes.number.isRequired,
};
